module.exports = __webpack_public_path__ + "img/twoCode.719c4d99.png";